import { FieldClaimDefault, FieldInsuredDefault } from '../../enums';
export class CompanyFields {
    company;
    fields;
    constructor(company) {
        this.company = company;
        this.fields = company.smartphoto?.fields;
    }
    static generate(fields, defaultFields = []) {
        const base = defaultFields.map((defaultField) => {
            const field = fields.find(({ properties }) => properties.includes(defaultField.properties[0]));
            if (!field) {
                return defaultField;
            }
            return field;
        });
        const fieldsFilters = fields.filter(({ label }) => !defaultFields.find(({ label: defaultLabel }) => label === defaultLabel));
        return [...new Set(base), ...fieldsFilters];
    }
    get insured() {
        return CompanyFields.generate(this.fields?.insured ?? [], FieldInsuredDefault);
    }
    get claim() {
        let defaultClaimFields = FieldClaimDefault;
        if (this.company.assignSelfadjustToAgent) {
            defaultClaimFields = [
                ...defaultClaimFields,
                {
                    label: 'assigned_agent_name',
                    type: 'list',
                    properties: ['assigned_agent_name'],
                    editable: true
                }
            ];
        }
        return CompanyFields.generate(this.fields?.claim ?? [], defaultClaimFields);
    }
    get vehicle() {
        return CompanyFields.generate(this.fields?.vehicle ?? []);
    }
}
